import "../scss/style.scss";
import "./anime.js"
import "./splide_setting.js"
import "./splide-extension-auto-scroll.min.js"
import "./index.js"
